import { render, staticRenderFns } from "./OrdenPagoCaja.vue?vue&type=template&id=16cf77aa&scoped=true&"
import script from "./OrdenPagoCaja.vue?vue&type=script&lang=js&"
export * from "./OrdenPagoCaja.vue?vue&type=script&lang=js&"
import style0 from "./OrdenPagoCaja.vue?vue&type=style&index=0&id=16cf77aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf77aa",
  null
  
)

export default component.exports